import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const RenderInWindows = ({ open, setOpen, imagePath, children }) => {
    const _window = useRef(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (open) {
            _window.current = window.open("", "", "width=1250, height=800, left=200, top=200");
            const curWindow = _window.current;
            if (curWindow) {
                curWindow.document.title = imagePath;

                // Copy styles to the new window
                document.querySelectorAll('link[rel="stylesheet"], style').forEach((stylesheet) => {
                    curWindow.document.head.appendChild(stylesheet.cloneNode(true));
                });

                curWindow.onbeforeunload = () => {
                    setReady(false);
                    setOpen(false);
                };

                setReady(true);
            }
        } else {
            _window.current?.close();
            setReady(false);
        }
    }, [open]);

    return open && ready && createPortal(children, _window.current?.document.body);
};

export default RenderInWindows;
